import React from 'react';
import { Pagination } from 'react-bootstrap';

interface SmartPaginationProps {
  currentPage: number;
  limit: number;
  currentItemsCount: number;
  onPageChange: (page: number) => void;
  /**
   * Количество страниц для отображения по каждую сторону от текущей.
   * @default 2
   */
  siblingCount?: number;
}

/**
 * Компонент пагинации, который отображает:
 * - Кнопку Prev
 * - Текущую страницу
 * - До `siblingCount` страниц слева и справа от текущей (если > 0)
 * - Кнопку Next (disabled, если текущих элементов меньше limit)
 */
export const SmartPagination: React.FC<SmartPaginationProps> = ({
  currentPage,
  limit,
  currentItemsCount,
  onPageChange,
  siblingCount = 2,
}) => {
  const hasMorePages = currentItemsCount >= limit;

  // Вычисляем диапазон страниц для отображения
  const startPage = Math.max(1, currentPage - siblingCount);
  const endPage = hasMorePages ? currentPage + siblingCount : currentPage;

  const pages = [];
  for (let page = startPage; page <= endPage; page++) {
    pages.push(page);
  }

  if (pages.length === 0) {
    // Если нет ни одной страницы (currentPage=1 и нет больше данных)
    return (
      <div className="d-flex justify-content-center">
        <Pagination>
          <Pagination.Prev disabled />
          <Pagination.Item active>{currentPage}</Pagination.Item>
          <Pagination.Next disabled />
        </Pagination>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center">
      <Pagination>
        <Pagination.Prev
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        />

        {pages.map((page) => (
          <Pagination.Item
            key={page}
            active={page === currentPage}
            onClick={() => {
              if (page !== currentPage) {
                onPageChange(page);
              }
            }}
          >
            {page}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={!hasMorePages} />
      </Pagination>
    </div>
  );
};
